export var dataKey = 'text';


//////////////////
// WEBPACK FOOTER
// /var/www/24tru/releases/20230713222349/htdocs-rails/node_modules/redux-form/es/util/eventConsts.js
// module id = 420
// module chunks = 0 1 2 3 4 5 6 7 8 9 10